module.exports = "<template>\n    <section>\n        <b-progress></b-progress>\n\n        <b-progress :value=\"20\"></b-progress>\n\n        <b-progress :value=\"40\" show-value></b-progress>\n\n        <b-progress :value=\"80\" show-value format=\"percent\"></b-progress>\n    </section>\n</template>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./docs/pages/components/progress/examples/ExSimple.vue
// module id = 1464
// module chunks = 25